export default __webpack_public_path__ + "static/media/cargo.fad41e0c.svg";